import { Swiper } from "swiper/react";
import SwiperCore, { Navigation, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/bundle";
import "./CSwiper.scss";

const CSwiper = (props) => {
  SwiperCore.use([Autoplay]);
  const { bT320, bT480, bT640, bT768, bT994 } = props;
  const breakpoints = {
    320: {
      slidesPerView: bT320,
    },
    480: {
      slidesPerView: bT480,
    },
    640: {
      slidesPerView: bT640,
    },
    768: {
      slidesPerView: bT768,
    },
    994: {
      slidesPerView: bT994,
    },
  };

  return (
    <div className="parent_Swiper">
      <Swiper
        breakpoints={breakpoints}
        spaceBetween={16}
        slidesPerView={props.sildeNumber}
        autoplay={{
          disableOnInteraction: false,
          delay: 4000,
          reverseDirection: false,
          waitForTransition: true,
          pauseOnMouseEnter: true,
        }}
      >
        {props.children}
      </Swiper>
    </div>
  );
};

export default CSwiper;
